export function TreatmentPlanForClipboard({
  treatmentPlan,
}: {
  treatmentPlan?: TreatmentPlan;
}) {
  switch (treatmentPlan?.type) {
    case "BASIC": {
      return (
        <div>
          <h4>Treatment Plan</h4>
          <div>
            <h5>Presenting Problem</h5>
            <div>{treatmentPlan.problem}</div>
          </div>
          <div>
            <h5>Goal</h5>
            <div
              dangerouslySetInnerHTML={{
                __html: treatmentPlan.goal ?? "",
              }}
            />
          </div>
          <div>
            <h5>Objective</h5>
            <div
              dangerouslySetInnerHTML={{
                __html: treatmentPlan.objective ?? "",
              }}
            />
          </div>
          <div>
            <h5>Treatment Frequency</h5>
            <div>{treatmentPlan.frequency}</div>
          </div>
          <div>
            <h5>Set reminder to review plan</h5>
            <div>{reminderToString(treatmentPlan.reminder)}</div>
          </div>
        </div>
      );
    }

    case "ADVANCED": {
      return (
        <div>
          <h4>Treatment Plan</h4>
          <div>
            <h5>Presenting Problem</h5>
            <div>{treatmentPlan.problem}</div>
          </div>
          <h5>Behavioral Definitions</h5>
          <div>{treatmentPlan.behaviors?.join(", ")}</div>
          <h5>Goal</h5>
          {treatmentPlan.goals?.map((goal, goalIndex) => (
            <div key={goal.value}>
              <h5>Goal {goalIndex + 1}</h5>
              <div>{goal.value}</div>
              {goal.objectives?.map((objective, objectiveIndex) => (
                <div>
                  <h6>Objective {objectiveIndex + 1}</h6>
                  <div>{objective.value}</div>
                  <h6>Interventions</h6>
                  {objective.interventions?.map(
                    (intervention, interventionIndex) => (
                      <div key={intervention}>
                        <div>
                          <b>Intervention {interventionIndex + 1}</b>
                        </div>
                        <div>{intervention}</div>
                      </div>
                    ),
                  )}
                </div>
              ))}
            </div>
          ))}
          <div>
            <h5>Treatment Frequency</h5>
            <div>{treatmentPlan.frequency}</div>
          </div>
          <div>
            <h5>Set reminder to review plan</h5>
            <div>{reminderToString(treatmentPlan.reminder)}</div>
          </div>
        </div>
      );
    }

    default: {
      return null;
    }
  }

  function reminderToString(reminder?: TreatmentPlan["reminder"]) {
    switch (reminder?.type) {
      case "AFTER":
        return `After ${reminder.value} days`;
      case "ONDATE":
        return `On ${new Date(reminder.value ?? "").toLocaleDateString()}`;
      default:
        return "None";
    }
  }
}
